var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editorSearchSeo"},_vm._l((_vm.blocks),function(block,index){return _c('div',{key:index,class:['editorSearchSeo__block', `editorSearchSeo__block--${block.type}`]},[_c(`editor-${_vm.$helper.kebabCase(block.type)}`,{tag:"component",attrs:{"data":block.data,"small":""}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }